/*
 * @Author: WangYuzhou
 * @Date: 2023-01-04 23:37:06
 * @LastEditors: WangYuzhou
 * @LastEditTime: 2024-06-11 22:09:19
 * @Description: TODO
 */
import Vue from 'vue'
import App from './App.vue'

import './assets/common.less'
import './assets/mixins.less'

import dataV from '@jiaminghi/data-view'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
//

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false

Vue.use(dataV)
Vue.use(VueAwesomeSwiper /* { 全局组件的默认选项 } */)
Vue.use(ElementUI)

new Vue({
  render: (h) => h(App)
}).$mount('#app')
//  30分钟后 在此页面 打开新页面
// setTimeout(() => {
//   window.open('https://new.big.tianzenb.com','_self')
// }, 1000 * 60 * 30 )
